export default __webpack_public_path__ + "static/media/withdraw-icon.94ec274b.webp";